import React, { useEffect, useRef, useState } from 'react';
import { Link, useFetcher, useNavigate } from "react-router-dom";


import { useDispatch, useSelector } from "react-redux";

import { Ismobiles, findJson, getBase64, getMemberinfo, numFormat } from "../utils/utils";
import { close, loadingflas, open } from '../redux/popupSlice';

import * as APIS from "../utils/service";
import consts from '../libs/consts';
import Input from './Input';
import Button from './Button';
import Radios from './Radios';
import Select from './Select';

//정보 수정 컴포넌트
const EditInfoBox = (props) => {
    const {
        viewValue,
        value,
        setValue,
        options,
        flag,
        setFlag,
        onEdit = () => { },
        valid = ""
    } = props
    return <>
        {flag === true ?
            <>
                <div>
                    {
                        options ?
                            <Select
                                divwidth={{ width: 120 }}
                                setValues={v => { setValue(v * 1) }}
                                values={value}
                                selectData={options}
                            /> :
                            <Input
                                className={`inputs`}
                                setValue={setValue}
                                value={value}
                                name="mb_phone"
                                // error={errmsg[0]}
                                valid={valid}
                                style={{
                                    width: 140
                                }}
                            />
                    }

                </div>
                <button type="button" className='links' style={{ marginLeft: 8 }} onClick={() => {
                    setFlag(false)
                    onEdit();
                }}>
                    저장
                </button>
            </>
            :
            <>
                {viewValue}
                <button type="button" className='links' style={{ marginLeft: 8 }} onClick={() => setFlag(true)}>
                    변경
                </button>
            </>
        }
    </>
}

export default function MemberControlRight(props) {

    const {
        memberinfos = {},
        listreflash = () => { }
    } = props;


    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { configdata } = useSelector(s => s.configReducer);

    const selectFile = useRef(null);
    const levelText = ['', '중개보조원', '공인중개사', '대표공인중개사'];
    const [phoneChflag, setphoneChflag] = useState(false);
    const [ranks, setranks] = useState('');
    const [errmsg, seterrmsg] = useState(['', '', '', '']);
    const [popflag, setpopflag] = useState(false);
    const [closeCker, setcloseCker] = useState('');

    //정보 관련
    const [pay_type, setpay_type] = useState(1)
    const [payTypeFlag, setpayTypeFlag] = useState(false);
    const [work_type, setwork_type] = useState(1)
    const [workTypeFlag, setworkTypeFlag] = useState(false);
    const [pay, setpay] = useState(0)
    const [payFlag, setpayFlag] = useState(false);
    const [pay_per, setpay_per] = useState(0)
    const [payPerFlag, setpayPerFlag] = useState(false);


    useEffect(() => {
        setphoneChflag(false);
        setpayTypeFlag(false)
        setworkTypeFlag(false)
        setpayFlag(false)
        setpayPerFlag(false)
        setranks(memberinfos?.rank);
        setpay_type(memberinfos?.pay_type);
        setwork_type(memberinfos?.work_type);
        setpay(memberinfos?.pay);
        setpay_per(memberinfos?.pay_per);
    }, [memberinfos]);
    const rankChSubmit = () => {
        if (ranks === '') {
            seterrmsg(errmsg?.map((xe, ie) => ie === 0 ? '직함을 입력해주세요' : xe));
            return;
        }

        dispatch(loadingflas({ loading: true }));
        //navigate('/Storeselctor');

        let sender = {
            idx: memberinfos?.idx,
            rank: ranks,
        }
        APIS.postData('/v1/master/rankUpdate', sender).then(({ data }) => {
            if (data) {
                setphoneChflag(false);
                listreflash();
            }
        }).catch(({ response }) => {
            const { data } = response;
            seterrmsg(errmsg?.map((xe, ie) => ie === 0 ? data?.msg : xe));
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });
    }
    //멤버정보 업데이트 (급여,근로,조건,기본급 등)
    const memberUpdateSubmit = (type, value) => {
        if (value === '') {
            return;
        }

        dispatch(loadingflas({ loading: true }));
        //navigate('/Storeselctor');

        let sender = {
            idx: memberinfos?.idx,
            type: type,
            value: value,
        }

        console.log("memberUpdateSubmit->", sender);
        APIS.postData('/v1/master/memberUpdate', sender).then(({ data }) => {
            if (data) {
                setphoneChflag(false);
                listreflash();
            }
        }).catch(({ response }) => {
            const { data } = response;
            seterrmsg(errmsg?.map((xe, ie) => ie === 0 ? data?.msg : xe));
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });
    }
    const companyretire = () => {
        dispatch(loadingflas({ loading: true }));
        //navigate('/Storeselctor');

        let sender = {
            idx: memberinfos?.idx,
        }
        APIS.postData('/v1/master/retire', sender).then(({ data }) => {
            if (data) {
                setpopflag(false);
                listreflash('nodata');
            }
        }).catch(({ response }) => {
            const { data } = response;
            seterrmsg(errmsg?.map((xe, ie) => ie === 0 ? data?.msg : xe));
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });
    }
    return (
        <>
            <div className='membercontrolinfoArea'>
                <div className='membercontrolheader'>
                    <div>직원 정보</div>
                    {memberinfos?.level * 1 !== 3 &&
                        <button
                            onClick={() => {
                                setpopflag(true);
                            }}
                        >
                            퇴사처리
                        </button>
                    }
                </div>

                <div>
                    <div className='membercontrolprofileImages'>
                        <div
                            style={{
                                backgroundImage: `${memberinfos?.profile ? "url('" + consts.s3url + "/" + memberinfos?.profile + "')" : "url('./images/icons/user-3-fill.svg')"}`,
                                backgroundSize: `${memberinfos?.profile ? "cover" : ""}`
                            }}
                        >
                        </div>
                    </div>
                    <div className="membercontrolinputtextviewtype1 ">
                        <div>이름</div>
                        <div>
                            {memberinfos?.name}
                        </div>
                    </div>
                    <div className="membercontrolinputtextviewtype1 ">
                        <div>회원유형</div>
                        <div>
                            {levelText[memberinfos?.level * 1]}
                        </div>
                    </div>
                    <div className="membercontrolinputtextviewtype1 ">
                        <div>직함</div>
                        <div style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                            {phoneChflag === true ?
                                <>
                                    <div>
                                        <Input
                                            className={`inputs`}
                                            setValue={setranks}
                                            value={ranks}
                                            name="mb_phone"
                                            error={errmsg[0]}
                                            style={{
                                                width: 140
                                            }}
                                        />
                                    </div>
                                    <button type="button" className='links' style={{ marginLeft: 8 }} onClick={() => { rankChSubmit(); }}>
                                        저장
                                    </button>
                                </>
                                :
                                <>
                                    {memberinfos?.rank}
                                    <button type="button" className='links' style={{ marginLeft: 8 }} onClick={() => setphoneChflag(true)}>
                                        변경
                                    </button>
                                </>
                            }

                        </div>
                    </div>
                    <div className="membercontrolinputtextviewtype1 ">
                        <div>휴대폰번호</div>
                        <div>
                            {memberinfos?.hp}
                        </div>
                    </div>
                    <div className="membercontrolinputtextviewtype1 ">
                        <div>급여조건</div>
                        <div style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                            <EditInfoBox
                                viewValue={configdata?.consts?.memberPayType?.find(v => v.idx === memberinfos?.pay_type * 1)?.title}
                                options={configdata?.consts?.memberPayType?.map(v => ({ labels: v?.title, values: v?.idx }))}
                                value={pay_type}
                                setValue={setpay_type}
                                flag={payTypeFlag}
                                setFlag={setpayTypeFlag}
                                onEdit={() => { memberUpdateSubmit(1, pay_type) }} />
                        </div>
                    </div>
                    <div className="membercontrolinputtextviewtype1 ">
                        <div>근로형태</div>
                        <div style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                            <EditInfoBox
                                viewValue={configdata?.consts?.memberWorkType?.find(v => v.idx === memberinfos?.work_type * 1)?.title}
                                options={configdata?.consts?.memberWorkType?.map(v => ({ labels: v?.title, values: v?.idx }))}
                                value={work_type}
                                setValue={setwork_type}
                                flag={workTypeFlag}
                                setFlag={setworkTypeFlag}
                                onEdit={() => { memberUpdateSubmit(2, work_type) }} />
                        </div>
                    </div>
                    <div className="membercontrolinputtextviewtype1 ">
                        <div>기본급</div>
                        <div style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                            <EditInfoBox
                                valid="num"
                                viewValue={numFormat(memberinfos?.pay) + " 원"}
                                value={pay}
                                setValue={v => {
                                    setpay(Math.floor(v))
                                }}
                                flag={payFlag}
                                setFlag={setpayFlag}
                                onEdit={() => { memberUpdateSubmit(3, pay) }} />
                        </div>
                    </div>
                    <div className="membercontrolinputtextviewtype1 ">
                        <div>비율</div>
                        <div style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                            <EditInfoBox
                                valid="num"
                                viewValue={memberinfos?.pay_per + " %"}
                                value={pay_per}
                                setValue={v => {
                                    if (v > 100) {
                                        setpay_per(100)
                                    } else {
                                        setpay_per(Math.floor(v))
                                    }
                                }}
                                flag={payPerFlag}
                                setFlag={setpayPerFlag}
                                onEdit={() => { memberUpdateSubmit(4, pay_per) }} />
                        </div>
                    </div>
                </div>

                <div className='membercontroldivline' />

                <div>
                    <div className='membercontrolboldstitle'>활동현황</div>
                    <div>
                        <div className='membercontrolTrophycountinfo'>
                            <div>
                                <div>전체<br />공동중개</div>
                                <div>{memberinfos?.mediation_count * 1 > 4 ? numFormat(memberinfos?.mediation_count) : '-'}건</div>
                            </div>
                            <div>
                                <div>최근 3개월간<br />공동중개</div>
                                <div className='lightblue'>{memberinfos?.mediation_count * 1 > 4 ? numFormat(memberinfos?.mediation_count_3m) : '-'}건</div>
                            </div>
                            <div>
                                <div>평가점수<br />(상위)</div>
                                <div className='lightblue'>{memberinfos?.mediation_count * 1 > 4 ? memberinfos?.score_per !== null ? memberinfos?.score_per : '-' : '-'}%</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='membercontroldivline' />

                <div>
                    <div className='membercontrolboldstitle'>칭호</div>
                    <div className="membercontrolinputtextviewtype1 ">
                        <div>공동중개 만족도</div>
                        <div>
                            {memberinfos?.badges?.filter(item => item.type === 1)?.map(item => item.title)?.join(", ") || '-'}
                        </div>
                    </div>

                    <div className="membercontrolinputtextviewtype1 ">
                        <div>중개 활동</div>
                        <div>
                            {memberinfos?.badges?.filter(item => item.type === 2)?.map(item => item.title)?.join(", ") || '-'}
                        </div>
                    </div>

                    <div className="membercontrolinputtextviewtype1 ">
                        <div>매물유형 전문가</div>
                        <div>
                            {memberinfos?.badges?.filter(item => item.type === 3)?.map(item => item.title)?.join(", ") || '-'}
                        </div>
                    </div>

                    <div className="membercontrolinputtextviewtype1 ">
                        <div>영구칭호</div>
                        <div>
                            {memberinfos?.badges?.filter(item => item.type === 4)?.map(item => item.title)?.join(", ") || '-'}
                        </div>
                    </div>

                    <div className="membercontrolinputtextviewtype1 ">
                        <div>특별칭호</div>
                        <div>
                            {memberinfos?.badges?.filter(item => item.type === 5)?.map(item => item.title)?.join(", ") || '-'}
                        </div>
                    </div>
                </div>
                <div className='membercontroldivline' />

                <div>
                    <div className='membercontrolboldstitle'>
                        <span>블랙리스트</span>
                        <span>{memberinfos?.myblacks?.length}명</span>
                    </div>
                    {memberinfos?.myblacks?.map((x, i) => {
                        console.log(x);
                        return (
                            <div className="membercontrolinputtextviewtype1 ">
                                {x?.targetUser?.compony?.title} | {x?.targetUser?.compony?.company_phone} | {x?.targetUser?.name} {x?.targetUser?.rank}
                            </div>
                        );
                    })}
                </div>
            </div>

            {popflag === true &&
                <div className='PopupArea'>
                    <div>
                        <div className='PopupAreaBG'
                            onClick={() => () => { }}
                        />
                        <div className='PopupAreaContents' style={{ width: 500 }}>
                            <div>
                                <div className="popTitle padding20">
                                    <span >퇴사 처리</span>
                                    <button
                                        onClick={() => {
                                            setpopflag(false);
                                            setcloseCker('');
                                        }}
                                    >
                                        <img src="./images/icons/x.svg" width='20' />
                                    </button>
                                </div>
                                <div className="padding32">
                                    <div className='popcontents'>
                                        <div style={{ width: '100%' }}>
                                            <div>
                                                <p className='alignc'>직원의 퇴사 처리가 완료되면 해당 직원의 매물·고객 정보는</p>
                                                <p className='bolds alignc'>1. 직원 계정에 귀속되며 대표에게 제공되지 않습니다.</p>
                                                <p className='bolds alignc'>2. 직원 계정에 귀속되며 동일한 내용이 대표 계정으로 복사됩니다.</p>
                                                <p className='bolds alignc'>3. 대표에게 귀속되며 직원에게 제공되지 않습니다.</p>
                                            </div>
                                            <div
                                                className='margint20'
                                                style={{
                                                    display: 'flex', alignItems: 'center', justifyContent: 'center'
                                                }}
                                            >
                                                <Radios
                                                    linetype={'checkimg'}
                                                    values={closeCker}
                                                    setvalues={(e) => {
                                                        if (closeCker === 0) {
                                                            setcloseCker('');
                                                        } else {
                                                            setcloseCker(e);
                                                        }
                                                    }}
                                                    namevalue={[
                                                        { names: '위 내용을 충분히 확인 하였으며, 퇴사처리 이후 복구 할 수 없음에 동의함.', values: 0 },
                                                    ]}
                                                    fontweights={400}
                                                    fontSizes={14}
                                                    sizes={20}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='popbuttons'>
                                        <div>
                                            <Button
                                                disabled={true}
                                                buttonTxt={'퇴사처리'}
                                                onPress={() => {
                                                    if (closeCker === 0) {
                                                        companyretire();
                                                    }
                                                }}
                                            />
                                        </div>
                                        <div>
                                            <Button
                                                disabled={false}
                                                buttonTxt={'아니오'}
                                                onPress={() => {
                                                    setpopflag(false);
                                                    setcloseCker('');
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            }
        </>
    )
}